import Assignment from './Assignment';

export default class Module {
  public readonly id;
  public name: string;
  public description: string;
  public is_public: boolean;
  public is_under_review: boolean;
  public tags: Array<string>;
  public learner_level: Array<string>;
  public topics: Array<string>;
  public classroom?: string;
  public key_words?: string[];
  public advanced_words?: string[];
  public assignments?: Assignment[];

  constructor(
    id: string,
    name: string,
    description: string,
    is_public: boolean,
    is_under_review: boolean,
    tags: Array<string>,
    learner_level: Array<string>,
    topics: Array<string>,
    classroom?: string,
    key_words?: string[],
    advanced_words?: string[],
    assignments?: Assignment[],
  ) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.is_public = is_public;
    this.is_under_review = is_under_review;
    this.tags = tags;
    this.learner_level = learner_level;
    this.topics = topics;
    this.classroom = classroom;
    this.key_words = key_words;
    this.advanced_words = advanced_words;
    this.assignments = assignments;
  }

  static fromModule(module: Module) {
    return new Module(
      module.id,
      module.name,
      module.description,
      module.is_public,
      module.is_under_review,
      module.tags,
      module.learner_level,
      module.topics,
      module.classroom,
      module.key_words,
      module.advanced_words,
      module.assignments,
    );
  }

  static fromServerModule(module: Record<string, any>): Module {
    return new Module(
      module['id'],
      module['name'],
      module['description'],
      module['is_public'],
      module['is_under_review'],
      module['tags'],
      module['learner_level'],
      module['topics'],
      module['classroom'],
      module['key_words'],
      module['advanced_words'],
      module['assignments'],
    );
  }

  public toJSON(): Record<string, any> {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      is_public: this.is_public,
      is_under_review: this.is_under_review,
      tags: this.tags,
      topics: this.topics.length ? JSON.stringify(this.topics) : undefined,
      learner_level: this.learner_level.length
        ? JSON.stringify(this.learner_level)
        : undefined,
      classroom: this.classroom,
      key_words: this.key_words,
      advanced_words: this.advanced_words,
    };
  }
}
